import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import VideoIllustration from '@wetransfer/transfer/component/illustration/video-illustration';
import TeamDiscoveryExperiment from '@wetransfer/transfer/constant/experiments/team-discovery-experiment';
import ExperimentTransferDetails04CtaUpdate from '@wetransfer/transfer/constant/experiments/transfer-details-04-cta-update';
import { userHasPaidTier } from '@wetransfer/transfer/helper/user';
import Browser from '@wetransfer/transfer/modules/concorde-browser';
import I18n from '@wetransfer/transfer/modules/i18n';
import { getIsForwardedTransfer } from '@wetransfer/transfer/transfer-bundle/store/selectors';

const determineCopy = (transfer, mobile = false, user) => {
  if (mobile) {
    return transfer.expiry === 'never'
      ? I18n.t('transfer.complete_mobile.email_text_no_expiry')
      : I18n.t('transfer.complete_mobile.email_text', {
          expires: I18n.relativeTime(transfer.expiryInSeconds),
        });
  }

  const completeText =
    TeamDiscoveryExperiment.isShowTeamDiscoveryExperiment() &&
    userHasPaidTier(user)
      ? 'transfer.complete_email.team_discovery_text'
      : 'transfer.complete_email.text';

  return transfer.expiry === 'never'
    ? I18n.t('transfer.complete_email.text_no_expiry')
    : I18n.t(completeText, {
        expires: I18n.relativeTime(transfer.expiryInSeconds),
      });
};

const Email = ({ isForwardedTransfer, transfer, onRequestClose, user }) => {
  const description = determineCopy(transfer, Browser.isMobile, user);

  const showTeamDiscoveryExperiment =
    TeamDiscoveryExperiment.isShowTeamDiscoveryExperiment() &&
    userHasPaidTier(user);

  const footerClassName = classNames('transfer__footer', {
    'team-discovery-footer': showTeamDiscoveryExperiment,
  });

  const buttonClassName = classNames('transfer__button', {
    'team-discovery-button': showTeamDiscoveryExperiment,
    'transfer__button--alt':
      ExperimentTransferDetails04CtaUpdate.isOn() &&
      user?.loggedIn === false &&
      !Browser.isMobile,
  });

  const h2ClassName = classNames({
    'team-discovery-h2': showTeamDiscoveryExperiment,
  });

  const buttonDoneText = showTeamDiscoveryExperiment
    ? 'transfer.buttons.team_discovery_done'
    : 'transfer.buttons.done';

  const nonForwardedCompletedTitle = showTeamDiscoveryExperiment
    ? I18n.t('transfer.complete_email.team_discovery_title')
    : I18n.t('transfer.complete_email.title');

  const title = isForwardedTransfer
    ? I18n.t('transfer.complete_forward.title')
    : nonForwardedCompletedTitle;

  return (
    <React.Fragment key="email">
      <div className="transfer__contents">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed"
          variants={3}
          className="uploader__image"
        />

        <h2 className={h2ClassName}>{title}</h2>
        <p
          className="complete__text"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <span className="transfer__contents--spacer" />
      </div>
      <div className={footerClassName}>
        <button className={buttonClassName} onClick={onRequestClose}>
          {I18n.t(buttonDoneText)}
        </button>
      </div>
    </React.Fragment>
  );
};

Email.propTypes = {
  transfer: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  isForwardedTransfer: PropTypes.bool,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  transfer: state.transfer,
  isForwardedTransfer: getIsForwardedTransfer(state),
  transferNotification: state.notification.transfer,
});

export { Email };

export default connect(mapStateToProps)(Email);
